const { VITE_APP_CLOUDFRONT_URL, VITE_APP_STORAGE_BUCKET_URL } = import.meta.env;

export function getMediaLink({ link, size }: { link?: string; size?: number }) {
  if (!link) {
    return "";
  }

  if (URL.canParse(link)) {
    return link;
  }

  if (size) {
    return `${VITE_APP_CLOUDFRONT_URL}/${link}?width=${size}`;
  }

  return `${VITE_APP_STORAGE_BUCKET_URL}/${link}`;
}
